import React from 'react';
import i18n from 'react-intl-universal';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';

export default ({ ...props }) => {
  const { classes, onChangActiveAgentView } = props;

  return (
    <List component="div" disablePadding>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.ActiveAgentView.allTransaction')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateActiveAgentAllTransaction}
            onChange={() =>
              onChangActiveAgentView(
                props.setActiveAgentViewAllTransaction,
                !props.filteringStateActiveAgentAllTransaction
              )
            }
            value="active agent"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get(
                'app.dashboard.sidebar.ActiveAgentView.withoutDisbursementCashout'
              )}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateActiveAgentWithoutDisbursementCashout}
            onChange={() =>
              onChangActiveAgentView(
                props.setActiveAgentViewWithoutDisbursementCashout,
                !props.filteringStateActiveAgentWithoutDisbursementCashout
              )
            }
            value="Without Disbursement Cashout"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get(
                'app.dashboard.sidebar.ActiveAgentView.partnerPaymentOnly'
              )}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateActiveAgentPartnerPaymentOnly}
            onChange={() =>
              onChangActiveAgentView(
                props.setActiveAgentViewPartnerPaymentOnly,
                !props.filteringStateActiveAgentPartnerPaymentOnly
              )
            }
            value="Without Disbursement Cashout"
          />
        </ListItemIcon>
      </ListItem>
    </List>
  );
};
